exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stars[data-v-50ad4f12]{overflow:hidden;display:block;white-space:nowrap}.stars .star[data-v-50ad4f12]{display:inline-block;height:100%;position:relative}.stars .star img[data-v-50ad4f12]{height:80%;width:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-50ad4f12","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/rating/default/Default.vue
// module id = 40870e3d8d47a21180b0
// module chunks = 0